import { InteractionStatus, InteractionType } from "@azure/msal-browser"
import { MsalAuthenticationTemplate } from "@azure/msal-react"
import { Root } from "App"
import { Loading } from "components"
import * as hooks from "lib/hooks"
import { Navigate, useLocation } from "react-router-dom"
import { RestrictedContactLayout } from "./RestrictedContactLayout"

const sectorAdminContactPath = "/mcc-access-contact-info"

export function AuthenticatedRoot() {
	const { inProgress, permissionErr, loading } = hooks.UseAuth()
	const location = useLocation()

	// 1. First check if MSAL is doing something
	if (!inProgress.Equal(InteractionStatus.None)) {
		return <Loading />
	}

	// 2.0 Then check if we have an authenticated account
	return (
		// eslint-disable-next-line react/jsx-no-comment-textnodes
		<MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
			{
				// 2.1 Check for permission errors: show minimal layout on contact page, else redirect
				permissionErr ? (
					location.pathname === sectorAdminContactPath ? (
						<RestrictedContactLayout />
					) : (
						<Navigate to={sectorAdminContactPath} />
					)
				) : // 2.2 Check if we have menu data
				loading ? (
					<Loading />
				) : (
					<Root />
				)
			}
		</MsalAuthenticationTemplate>
	)
}
